import {EntryPath} from './nativeLaunchTypes'

export function convertEntryPathToRoute(entryPath: EntryPath): string {
  // This layer detaches the backend-side naming conventions from the frontend routing conventions.
  let basePath: string

  switch (entryPath.workflow) {
    case 'build':
      basePath = `/build/${entryPath.resourceId ?? ''}`
      break
    case 'taking':
      basePath = `/taking/${entryPath.resourceId ?? ''}`
      break
    case 'observing':
      basePath = `/observing/${entryPath.resourceId ?? ''}`
      break
    case 'course_concluded':
      return '/course_concluded'
    case 'item_banks':
      return '/banks'
    case 'errors':
      return '/errors/400'
    default:
      return '/errors/400'
  }

  // Append action if provided (e.g., "take" for /taking/20/take)
  if (entryPath.action) {
    basePath = `${basePath}/${entryPath.action}`
  }

  return basePath
}
